import { SimplifyDeep } from 'type-fest'

import { useRecurringAssignment, useRecurringAssignments } from '..'

type Attrs = Parameters<typeof useRecurringAssignments>[0]

export const DEFAULT_RECURRING_ASSIGNMENT_INCLUDE = {
    practitioner: { dipsResource: true },
    monday_status: true,
    tuesday_status: true,
    wednesday_status: true,
    thursday_status: true,
    friday_status: true,
    saturday_status: true,
    sunday_status: true,
    monday_room: true,
    tuesday_room: true,
    wednesday_room: true,
    thursday_room: true,
    friday_room: true,
    saturday_room: true,
    sunday_room: true,
} as const

export function useActiveRecurringAssignments(attrs?: Attrs) {
    return useRecurringAssignments({ where: { ...(attrs ?? {}), entity_status: 'active' }, include: DEFAULT_RECURRING_ASSIGNMENT_INCLUDE })
}

export function useActiveRecurringAssignment(attrs: Attrs) {
    return useRecurringAssignment({ where: { ...(attrs ?? {}), entity_status: 'active' }, include: DEFAULT_RECURRING_ASSIGNMENT_INCLUDE })
}

export type RecurringAssignmentTypes = SimplifyDeep<ReturnType<typeof useActiveRecurringAssignments>>
export type RecurringAssignmentType = RecurringAssignmentTypes[number]
